import styled from 'styled-components';

export const MaxWidthWrapper = styled.div`
  max-width: 1440px;
  margin: auto;
  height: 100%;
`;

export const LoadingStyle = styled.div`
  width: 100vw;
  height: 100vh;
`;
